import { useState, useEffect, useRef, useCallback } from 'react';
import Editable from '../Editable';
import { useSection } from '../useSection';
import { authFetch } from '../../auth';
import { ContactFormPreview } from '../FormPreview';

const OFFICES = '/api/cms/offices';

/** 문의하기 — 연락처(본사 오피스) 편집·저장. 헤더 문구는 inquiry/ui 섹션. */
export default function Inquiry({ onRegisterSave, onRegisterDirty, refreshKey = 0 }) {
  const [office, setOffice] = useState(undefined);
  const ref = useRef(null);
  const dirtyRef = useRef(false);
  const { data: ui, setField, saveSection, isDirty: uiIsDirty } = useSection('inquiry', 'ui', 1);

  useEffect(() => {
    let alive = true;
    authFetch(`${OFFICES}?lang=ko`).then((r) => r.json())
      .then((d) => { if (alive) { const o = d[0] || null; ref.current = o; setOffice(o); } })
      .catch(() => { if (alive) setOffice(null); });
    return () => { alive = false; };
  }, [refreshKey]);

  const update = (f, v) => { dirtyRef.current = true; ref.current = { ...ref.current, [f]: v }; setOffice(ref.current); };

  const save = useCallback(async () => {
    const o = ref.current;
    if (!o) return;
    const res = await authFetch(OFFICES, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ intNum: o.intNum, name: o.name, addr: o.addr, email: o.email, tel: o.tel, fax: o.fax, mapQuery: o.mapQuery, sort: o.sort }),
    });
    if (!res.ok) throw new Error(`연락처 저장 실패 (${res.status})`);
    await saveSection();
    dirtyRef.current = false;
  }, [saveSection]);

  useEffect(() => { if (onRegisterSave) onRegisterSave(save); return () => { if (onRegisterSave) onRegisterSave(null); }; }, [save, onRegisterSave]);

  const isDirty = useCallback(() => dirtyRef.current || uiIsDirty(), [uiIsDirty]);
  useEffect(() => { if (onRegisterDirty) onRegisterDirty(isDirty); return () => { if (onRegisterDirty) onRegisterDirty(null); }; }, [isDirty, onRegisterDirty]);

  if (office === undefined) {
    return <section className="section pt-page"><div className="container"><p className="heading-sub color-muted">불러오는 중…</p></div></section>;
  }
  const o = office || {};

  return (
    <section className="section pt-page">
      <div className="container">
        <div className="contact-grid">
          <div className="contact-txt">
            <Editable as="h1" className="heading-page" value={ui.title || '문의하기'} onChange={(t) => setField('title', t)} />
            <Editable as="p" value={ui.intro || '제품 견적, 기술 상담, 파트너십 등 어떤 문의든 환영합니다. 아래 양식을 작성해 주시면, 당사 엔지니어링 팀이 영업일 기준 1일 이내에 회신드립니다.'} onChange={(t) => setField('intro', t)} />
            <ul className="contact-info-list mt-xl">
              <li><Editable className="link-underline" value={o.email || ''} onChange={(t) => update('email', t)} /></li>
              <li><Editable className="link-underline" value={o.tel || ''} onChange={(t) => update('tel', t)} /></li>
              <li><Editable value={o.fax || ''} onChange={(t) => update('fax', t)} /></li>
            </ul>
          </div>
          <ContactFormPreview />
        </div>
      </div>
    </section>
  );
}
